import { createRoute, redirect } from "@tanstack/react-router";
import { Route } from "./__root";

// nani club OIDC 登入回程的落點（RedirectURI 註冊此路徑）。
export const naniClubRedirectRoute = createRoute({
  getParentRoute: () => Route,
  path: "/nani-club-redirect",
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
